<template>
    <span :class="textClass">{{ row.AlacakStr ||'-' }}</span>
</template>

<script>
export default {
    props:{
        fields:[String,Number],
        row:Object
    },
    computed:{
        textClass(){
            if(this.row.Alacak > 0) return 'text-success font-weight-bolder'
            else return null
        }
    }
}
</script>